'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

require('../util/validators/password-validator.js');
var strings = require('../util/helpers/strings.js');
require('../util/helpers/date.js');
require('../util/helpers/arrays.js');
require('../util/helpers/language.js');
require('../util/helpers/numbers.js');
var Vue = _interopDefault(require('vue'));
var index = require('../routing/index.js');
var Component = require('vue-class-component');
var Component__default = _interopDefault(Component);
var link = require('../routing/link/link.js');
var parts_util = require('./utils/parts.util.js');
require('../util/helpers/currency.js');
require('../util/helpers/dom.js');
require('../util/helpers/debounce.js');
require('../util/helpers/throttle.js');
require('../util/helpers/functions.js');
require('../util/helpers/session.js');
require('../util/helpers/forms.js');
require('../util/helpers/keys.js');
require('../util/helpers/game.js');
require('../util/helpers/game-category.js');
require('../util/helpers/script.js');
require('../util/helpers/events.js');
require('../util/helpers/password.js');
require('../util/helpers/storage.js');
require('../util/helpers/theming.js');
require('../util/helpers/objects.js');
require('../util/helpers/slots.js');
require('../util/helpers/phone.js');
require('../util/validators/date-validator.js');
require('../util/validators/debounce-validator.js');
require('../util/types/input.js');
require('../util/types/device.enum.js');

var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
(function(ThumbnailType2) {
  ThumbnailType2["SEARCH"] = "search";
  ThumbnailType2["HOME"] = "home";
  ThumbnailType2["LAST_PLAYED"] = "lastPlayed";
  ThumbnailType2["REWARD_MODAL"] = "rewardModal";
  ThumbnailType2["PROMOTION_GAMES"] = "promotionGames";
  ThumbnailType2["FREE_TO_PLAY"] = "freeToPlay";
})(exports.ThumbnailType || (exports.ThumbnailType = {}));
const magicConfig = {
  mobile: false,
  tablet: false,
  desktop: false
};
function generateSetter(name) {
  return (value) => {
    if (magicConfig.hasOwnProperty(name)) {
      magicConfig[name] = value;
    } else {
      Vue.set(magicConfig, name, value);
    }
  };
}
const setTranslations = generateSetter("translations");
function addTranslations(translations) {
  if (magicConfig.hasOwnProperty("translations")) {
    magicConfig.translations = __spreadValues(__spreadValues({}, magicConfig.translations), translations);
  } else {
    Vue.set(magicConfig, "translations", translations);
  }
}
const setMobile = generateSetter("mobile");
const setTablet = generateSetter("tablet");
const setDesktop = generateSetter("desktop");
const setInterpolationParams = generateSetter("interpolationParams");
function updateInterpolationParams(params) {
  setInterpolationParams(__spreadValues(__spreadValues({}, magicConfig.interpolationParams), params));
}
const setLanguage = generateSetter("language");
const setRouteGetter = generateSetter("getRoute");
const setUiBackgroundConfig = generateSetter("uiBackgroundConfig");
const setWallet = generateSetter("wallet");
function translate(key, params) {
  if (!magicConfig.translations) {
    console.warn("Wand translation error: translations obj is empty");
    return "";
  }
  if (!magicConfig.translations.hasOwnProperty(key)) {
    return "";
  }
  let interpolateParams = magicConfig.interpolationParams;
  if (params) {
    interpolateParams = __spreadValues(__spreadValues({}, interpolateParams), params);
  }
  return strings.interpolate(magicConfig.translations[key] || "", interpolateParams);
}
function translationExists(key) {
  if (!magicConfig.translations) {
    console.warn("Wand translation error: translations obj is empty");
    return false;
  }
  return magicConfig.translations.hasOwnProperty(key);
}
const setPaths = generateSetter("paths");
const setCurrencyMultipliers = generateSetter("currencyMultipliers");
exports.MagicConfigMixin = class extends Vue {
  constructor() {
    super(...arguments);
    this.magicConfig = magicConfig;
    this.RoutablePage = index.RoutablePage;
  }
  beforeCreate() {
    this.$t = translate;
    this.$p = parts_util.partsBinder;
  }
  routeTo(link) {
    return this.magicConfig.getRoute(link).go();
  }
  getHref(link) {
    return this.magicConfig.getRoute(link).href;
  }
  isRouteActive(link) {
    const currRoute = this.magicConfig.getRoute(link);
    return currRoute.isActive ? currRoute.isActive() : false;
  }
  get $filteredAttrs() {
    return Object.entries(this.$attrs).filter(([key]) => {
      return !key.startsWith("data-v") && key !== "style";
    }).reduce((prev, [key, value]) => {
      prev[key] = value;
      return prev;
    }, {});
  }
};
exports.MagicConfigMixin = __decorateClass([
  Component__default({
    inheritAttrs: false,
    components: {
      "magic-router-link": link.default
    },
    filters: {
      translate
    }
  })
], exports.MagicConfigMixin);

exports.addTranslations = addTranslations;
exports.magicConfig = magicConfig;
exports.setCurrencyMultipliers = setCurrencyMultipliers;
exports.setDesktop = setDesktop;
exports.setInterpolationParams = setInterpolationParams;
exports.setLanguage = setLanguage;
exports.setMobile = setMobile;
exports.setPaths = setPaths;
exports.setRouteGetter = setRouteGetter;
exports.setTablet = setTablet;
exports.setTranslations = setTranslations;
exports.setUiBackgroundConfig = setUiBackgroundConfig;
exports.setWallet = setWallet;
exports.translate = translate;
exports.translationExists = translationExists;
exports.updateInterpolationParams = updateInterpolationParams;
